"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const enums_1 = require("../@shared-types/customer/enums");
const customer_1 = require("../shared/models/customer/customer");
let CustomerFormComponent = class CustomerFormComponent {
    constructor(customer) {
        this.customer = customer;
        this.returnCustomer = new core_1.EventEmitter();
        this.mode = 'ADD';
        this.selectOptions = {
            customerTypes: {
                [enums_1.ECustomerType.COMMERCIAL]: 'Geschäft',
                [enums_1.ECustomerType.PRIVATE]: 'Privatperson',
            },
            salutation: {
                [enums_1.ESalutation.FEMALE]: 'Frau',
                [enums_1.ESalutation.MALE]: 'Herr',
                [enums_1.ESalutation.OTHER]: 'Andere',
            },
            countries: {
                DE: 'Deutschland',
                AT: 'Österreich',
                CH: 'Schweiz',
                OTHER: 'Anderes Land',
            },
        };
        this.customerModel = {
            type: enums_1.ECustomerType.PRIVATE,
            salutation: enums_1.ESalutation.OTHER,
            firstName: '',
            lastName: '',
            companyName: '',
            address1: '',
            address2: '',
            city: '',
            country: 'DE',
            email: '',
            phone: '',
            title: '',
            zip: '',
        };
        this.sending = false;
        this.formSubmission = () => __awaiter(this, void 0, void 0, function* () {
            this.sending = true;
            let customer;
            if (this.mode === 'ADD') {
                customer = yield this.customer.post(this.customerModel);
            }
            else {
                const update = JSON.parse(JSON.stringify(this.customerModel));
                /** Only submit values with content */
                Object.entries(update).forEach(([i, v]) => {
                    if (!v)
                        delete update[i];
                });
                customer = yield this.customer.put(update, this.customerId || '');
            }
            this.sending = false;
            if (this.returnCustomer) {
                this.returnCustomer.emit(customer);
            }
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.customerId)
                return;
            this.mode = 'EDIT';
            const c = yield this.customer.get(this.customerId);
            const { id, externalId, creationDate, modificationDate, modificationUserId, creationUserId } = c, customer = __rest(c, ["id", "externalId", "creationDate", "modificationDate", "modificationUserId", "creationUserId"]);
            this.customerModel = customer;
        });
    }
};
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], CustomerFormComponent.prototype, "returnCustomer", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CustomerFormComponent.prototype, "customerId", void 0);
CustomerFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'customer-form',
        templateUrl: require('./customer-form.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _a : Object])
], CustomerFormComponent);
exports.default = CustomerFormComponent;
